import { render, staticRenderFns } from "./InscriptionsDataTable.vue?vue&type=template&id=26e7cb12&scoped=true"
import script from "./InscriptionsDataTable.vue?vue&type=script&lang=js"
export * from "./InscriptionsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e7cb12",
  null
  
)

export default component.exports